import React, { Component } from "react";
import "../../eventQuestion.css";
import Modal from "../shared/Modal";
import TopicReco from "./TopicReco";
import SeriesReco from "./SeriesReco";
import ExpertReco from "./ExpertReco";
import CompanyReco from "./CompanyReco";

class QuestionPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openOnboardingQuestionPopup: this.props.showQuestionPopup ? this.props.showQuestionPopup : false,
            currentQues: 0,
            prevQues: 0,
            userResponses: [],
            warningClass: "dNone",
            nextBtnText: "Next",
            initialVisibility: "hide",
            fetchNewObjects: true
        };
    }

    componentDidMount = () => {
        setTimeout(() => {
            this.setState({ initialVisibility: "" });
            localStorage.removeItem("askOnboardingQues");
        }, this.props.wait);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.showQuestionPopup !== prevProps.showQuestionPopup && this.props.showQuestionPopup) {
            this.openModal();
        }
        if (this.props.allQues.length == 1 && this.state.nextBtnText != "Done") {
            this.setState({
                nextBtnText: "Done"
            });
        }
    }

    openModal = () => {
        this.setState({
            openOnboardingQuestionPopup: true
        });
    };

    closeModal = () => {
        this.resetPopupProps();
    };

    resetPopupProps = () => {
        this.setState({
            openOnboardingQuestionPopup: false
        });
        this.props.questionPopupClosedHandler();
    };

    nxtQuesClickHandler = () => {
        if (this.state.currentQues + 1 == this.props.allQues.length) { //last question
            this.setState({
                userResponses: this.removeObjectWithEmptyResponses(this.state.userResponses)
            }, () => {
                this.props.questionSuccessHandler(this.state.userResponses);
            });
        }
        this.setState({
            currentQues: this.state.currentQues + 1,
            prevQues: this.state.currentQues
        });
    };

    disabledNxtQuesClickHandler = () => {
        this.setState({
            warningClass: "form_note"
        });
    };

    prevQuesClickHandler = () => {
        this.setState({
            currentQues: this.state.currentQues - 1,
            nextBtnText: 'Next',
            prevQues: this.state.currentQues,
            warningClass: "dNone"
        });
    };

    optionchoosedHandler = (quesId, optionIndex, optionValue, quesType) => {
        const updatedCheckBoxEnabled = document.getElementById(`ques${quesId}option${optionIndex}`).checked;
        if (updatedCheckBoxEnabled) {

            if (this.isQuesObjectExist(this.state.userResponses, quesId)) { // ques response object already exist
                this.setState({
                    userResponses: this.updateResponse(this.state.userResponses, quesId, optionValue, quesType)
                });
            } else {
                let userJsonResponse = { "questionId": quesId, "response": optionValue };
                this.setState({
                    userResponses: [...this.state.userResponses, userJsonResponse]
                });
            }
            this.setState({
                warningClass: "dNone"
            });
        } else {
            this.setState({
                userResponses: this.removeSelectedOption(this.state.userResponses, quesId, optionValue)
            });
        }
    };

    freeTextRespHanler = (quesId, quesType) => {
        const freeTxtResp = document.getElementById(`ques${quesId}`).value;
        if (this.isQuesObjectExist(this.state.userResponses, quesId)) { // ques response object already exist
            this.setState({
                userResponses: this.updateResponse(this.state.userResponses, quesId, freeTxtResp, quesType)
            });
        } else {
            let userJsonResponse = { "questionId": quesId, "response": freeTxtResp };
            this.setState({
                userResponses: [...this.state.userResponses, userJsonResponse]
            });
        }
        this.setState({
            warningClass: "dNone"
        });
    };

    fetchSavedFreeTextResp = (quesId) => {
        let savedFreeTextResp = '';
        if (this.isQuesObjectExist(this.state.userResponses, quesId)) { // ques response object already exist
            let respArr = this.state.userResponses;
            for (var index = 0; index < respArr.length; ++index) {
                if (respArr[index].questionId == quesId) {
                    savedFreeTextResp = respArr[index].response;
                    break;
                }
            }
        }
        return savedFreeTextResp;
    };

    isQuesObjectExist = (JSON, quesId) => {
        let hasMatch = false;

        for (var index = 0; index < JSON.length; ++index) {
            if (JSON[index].questionId == quesId) {
                hasMatch = true;
                break;
            }
        }
        return hasMatch;
    };

    updateResponse = (respArr, quesId, optionValue, quesType) => {
        let updatedResponses = "";
        for (var index = 0; index < respArr.length; ++index) {
            if (respArr[index].questionId == quesId) {
                if (quesType == 'SINGLE_SELECT' || quesType == 'FREE_TEXT') {
                    respArr[index].response = optionValue;
                } else {
                    if (respArr[index].response) {
                        respArr[index].response = respArr[index].response + "," + optionValue;
                    } else {
                        respArr[index].response = optionValue;
                    }
                }
                updatedResponses = respArr;
                break;
            }
        }
        return updatedResponses;
    };

    removeSelectedOption = (respArr, quesId, optionValue) => {
        let updatedResponses = "";
        for (var index = 0; index < respArr.length; ++index) {
            if (respArr[index].questionId == quesId) {
                var optionArr = respArr[index].response.split(',');
                var optionIndex = optionArr.indexOf(optionValue);
                if (optionIndex !== -1) {
                    optionArr.splice(optionIndex, 1);
                }
                respArr[index].response = optionArr.toString();
                updatedResponses = respArr;
                break;

            }
        }
        return updatedResponses;
    };

    removeObjectWithEmptyResponses = (respArr) => {
        let updatedResponses = [];
        for (var index = 0; index < respArr.length; ++index) {
            if (respArr[index].response !== "") {
                updatedResponses.push(respArr[index]);
            }
        }
        return updatedResponses;
    };

    isThisCheckboxEnabled = (respArr, quesId, optionValue) => {
        let isThisCheckboxEnabled = false;
        for (var index = 0; index < respArr.length; ++index) {
            if (respArr[index].questionId == quesId) {
                var optionArr = respArr[index].response.split(',');
                var optionIndex = optionArr.indexOf(optionValue);
                if (optionIndex !== -1) {
                    isThisCheckboxEnabled = true;
                }
                break;
            }
        }
        return isThisCheckboxEnabled;
    };

    isNextAllowed = (quesId, isMandatory, respArr) => {
        let isNextAllowed = false;
        if (!isMandatory) {
            isNextAllowed = true;
        } else {
            for (var index = 0; index < respArr.length; ++index) {
                if (respArr[index].questionId == quesId) {
                    if (respArr[index].response !== "") {
                        isNextAllowed = true;
                        break;
                    }
                }
            }
        }
        return isNextAllowed;
    };

    render() {
        return (
            <div className={this.state.initialVisibility}>
                <Modal
                    openPopup={this.state.openOnboardingQuestionPopup}
                    resetPopupProps={this.resetPopupProps}
                    modalID="onboardingQuestionModal"
                    key={this.state.openOnboardingQuestionPopup}
                >
                    <div className="popup_register show-popup question-poup-model">
                        <div className="header_section">
                            <h2>Let’s get started
                                <span className="sub_heading">Just a few questions to personalise your ausbiz experience</span>
                            </h2>
                        </div>
                        <div className={this.state.currentQues - 3 == this.props.allQues.length ? "popup_register_body watch-company" : "popup_register_body"}>
                            {/* {this.props.allQues.length > 1 && */}
                            <span className="question_count">
                                {this.state.currentQues != 0 && this.state.currentQues !== this.props.allQues.length &&
                                    <span className="backButton" onClick={this.prevQuesClickHandler}></span>
                                }
                            </span>
                            {/* } */}
                            {this.state.currentQues < this.props.allQues.length &&
                                <div className="popup_register_block">
                                    <h3 className="question">
                                        {this.props.allQues[this.state.currentQues]?.question}
                                        {this.props.allQues[this.state.currentQues]?.isMandatory &&
                                            <span className="mondatry_feild">*</span>
                                        }
                                        <span>{this.props.allQues[this.state.currentQues]?.description}</span>
                                    </h3>
                                    {this.props.allQues[this.state.currentQues]?.type == 'MULTIPLE_SELECT' &&
                                        <span className="select_options">Select as many options as you like</span>
                                    }
                                    <div className="question_list">
                                        {this.props.allQues[this.state.currentQues]?.type !== 'FREE_TEXT' &&
                                            <ul>
                                                {this.props.allQues[this.state.currentQues]?.validResponses.map((value, index) => (
                                                    <li key={value + index}>
                                                        <div className="question_item">
                                                            <input type="checkbox" id={`ques${this.props.allQues[this.state.currentQues].id}option${index}`} checked={this.isThisCheckboxEnabled(this.state.userResponses, this.props.allQues[this.state.currentQues].id, value)} onChange={() => this.optionchoosedHandler(this.props.allQues[this.state.currentQues].id, index, value, this.props.allQues[this.state.currentQues].type)} />
                                                            <label htmlFor={`ques${this.props.allQues[this.state.currentQues].id}option${index}`}>{value}</label>
                                                        </div>
                                                    </li>
                                                ))
                                                }
                                            </ul>
                                        }
                                        {this.props.allQues[this.state.currentQues]?.type == 'FREE_TEXT' &&
                                            <textarea
                                                className="poup-model-textarea"
                                                maxLength="250"
                                                id={`ques${this.props.allQues[this.state.currentQues].id}`}
                                                placeholder="Type your message here (250 character limit)"
                                                value={this.fetchSavedFreeTextResp(this.props.allQues[this.state.currentQues].id)}
                                                onChange={() => this.freeTextRespHanler(this.props.allQues[this.state.currentQues].id, this.props.allQues[this.state.currentQues]?.type)}
                                            >
                                            </textarea>
                                        }
                                    </div>
                                </div>
                            }
                            <TopicReco
                                show={this.state.currentQues == this.props.allQues.length}
                                fetchNew={this.state.currentQues > this.state.prevQues && this.state.currentQues == this.props.allQues.length}
                                currentLanguage={this.props.currentLanguage}
                            />
                            <SeriesReco
                                show={this.state.currentQues - 1 == this.props.allQues.length}
                                fetchNew={this.state.currentQues > this.state.prevQues && this.state.currentQues - 1 == this.props.allQues.length}
                                currentLanguage={this.props.currentLanguage}
                            />
                            <ExpertReco
                                show={this.state.currentQues - 2 == this.props.allQues.length}
                                fetchNew={this.state.currentQues > this.state.prevQues && this.state.currentQues - 2 == this.props.allQues.length}
                                currentLanguage={this.props.currentLanguage}
                            />
                            <CompanyReco
                                userResponses={this.state.userResponses}
                                availableSubscriptions={this.props.availableSubscriptions}
                                show={this.state.currentQues - 3 == this.props.allQues.length}
                                questionPopupClosedHandler={this.props.questionPopupClosedHandler}
                            />
                            {this.state.currentQues - 3 !== this.props.allQues.length &&
                                <div className="question_modal_footer">
                                    {this.props.allQues[this.state.currentQues]?.isMandatory &&
                                        <span className={this.state.warningClass}>Please provide a response to continue.</span>
                                    }
                                    {!this.isNextAllowed(this.props.allQues[this.state.currentQues]?.id, this.props.allQues[this.state.currentQues]?.isMandatory, this.state.userResponses) &&
                                        <button className="registration_button disabledCustom" onClick={this.disabledNxtQuesClickHandler}>
                                            {this.state.nextBtnText}
                                        </button>
                                    }
                                    {this.isNextAllowed(this.props.allQues[this.state.currentQues]?.id, this.props.allQues[this.state.currentQues]?.isMandatory, this.state.userResponses) &&
                                        <button className="registration_button" onClick={this.nxtQuesClickHandler}>
                                            {this.state.nextBtnText}
                                        </button>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
};

export default QuestionPopup;
